import { Box, BoxProps } from '@chakra-ui/react'
import * as React from 'react'

import { Property } from 'csstype'

type Props = BoxProps & {
  svg: React.ReactElement
  stroke?: Property.Stroke
  fill?: Property.Fill
}

const SVG: React.FC<Props> = ({ svg, stroke, fill, ...others }) => {
  return (
    <>
      <Box
        as="span"
        display="inline-block"
        css={{
          'svg *': {
            stroke: stroke,
            fill: fill,
          },
        }}
        {...others}
      >
        {React.cloneElement(svg, { width: '100%', height: '100%' })}
      </Box>
    </>
  )
}

export default SVG
